export function translations(): string {
    return 'translations';
}
